import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Query, withApollo } from 'react-apollo'
import gql from 'graphql-tag'
import moment from 'moment'
import { withRouter } from 'react-router'

import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import CardActions from '@material-ui/core/CardActions'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import FormControl from '@material-ui/core/FormControl'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'
import Select from '@material-ui/core/Select'
import Hidden from '@material-ui/core/Hidden'
import FileDownloadIcon from '@material-ui/icons/FileDownload'
import getAccountType from '../../../utils/getAccountType'
import PaymentMethod from './PaymentMethod'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import getLoginId from '../../../utils/getLoginId'
import Loader from '../../../components/common/Loader'
import BillingDetails from './BillingDetails_Subscription'
import ConfirmationalDialog from '../../common/ConfirmationDialog'
const GET_SUBSCRIPTION = gql`
  query getSubscriptions($subscriptionId: Int) {
    subscription: getSubscriptions(id: $subscriptionId) {
      id
      status
      gst
      client {
        loginId
        clientName
        salesPerson {
          name
        }
      }
      billingMode {
        id
        billingMode
      }
      billingFrequency {
        id
        frequency
      }
      deviceQuantity
      simQuantity
      accessoryQuantity
      plan
      amount
      createdAt
      nextPaymentDate
      unAssignedDeviceQuantity
      unAssignedAccessoryQuantity
      unAssignedSimQuantity
      minimumAmountDue
      salesRemarks
      invoiceDownloadLink
      billingDetails {
        paymentId
        totalAmount
        totalAmountWithGST
        softwareBill {
          quantity
          rate
          amountWithGST
          amountToBePaid
          amountPaidGST
        }
        hardwareBill {
          quantity
          rate
          amountWithGST
          amountToBePaid
          amountPaidGST
        }
        accessoryBill {
          quantity
          rate
          amountWithGST
          amountToBePaid
          amountPaidGST
        }
        simBill {
          quantity
          rate
          amountWithGST
          amountToBePaid
          amountPaidGST
        }
      }
    }
  }
`

const APPROVE_REJECT_SUBSCRIPTION = gql`
  mutation(
    $clientLoginId: Int!
    $paymentId: Int!
    $subscriptionId: Int!
    $approveOrReject: approveOrReject!
    $paidDetails: inputBillingDetails
    $paymentMode: paymentMode
    $bankName: String
    $referenceNumber: String
    $paymentRemarks: String
  ) {
    approveOrRejectSubscription(
      clientLoginId: $clientLoginId
      paymentId: $paymentId
      subscriptionId: $subscriptionId
      approveOrReject: $approveOrReject
      paidDetails: $paidDetails
      paymentMode: $paymentMode
      bankName: $bankName
      referenceNumber: $referenceNumber
      paymentRemarks: $paymentRemarks
    )
  }
`

const DELETE_SUBSCRIPTION = gql`
  mutation($id: Int!, $clientLoginId: Int!, $partnerLoginId: Int!) {
    deleteSubscription(
      id: $id
      clientLoginId: $clientLoginId
      partnerLoginId: $partnerLoginId
    )
  }
`

const styles = theme => ({
  card: {},
  cardAction: {
    marginRight: theme.spacing.unit
  },
  redButton: {
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.dark
    }
  },
  // buttonBase: {
  //   width: '100%',
  //   textAlign: 'left'
  // },
  selectStyle: {
    minWidth: 250
  },
  fileDownloadIcon: {
    marginLeft: theme.spacing.unit,
    marginRight: -theme.spacing.unit
  },
  centerAlign: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  billingDetail: {
    margin: '10px 0'
  }
})

const paymentOption = ['NONE', 'CASH', 'ONLINE', 'CHEQUE', 'DD']

class SubscriptionDetails extends Component {
  constructor(props) {
    super(props)
    this.subscriptionId = this.props.subscriptionId
    this.clientLoginId = this.props.clientLoginId
    this.viewVehicles = this.props.viewVehicles
    this.clientDetail = this.props.clientDetail
    this.loginId = this.props.match.params.loginId
  }

  state = {
    paymentMode: '',
    error: true,
    referenceNumber: null,
    bankName: null,
    isValidReferenceNumber: true,
    referenceMessage: '',
    paidMoney: '',
    accountRemarks: '',
    validation: false,
    hardwarePaymentMade: 0,
    softwarePaymentMade: 0,
    accessoryPaymentMade: 0,
    simPaymentMade: 0,
    paymentId: 0,
    hardwareBalance: 0,
    softwareBalance: 0,
    accessoryBalance: 0,
    simBalance: 0,
    hardwareRemarks: null,
    softwareRemarks: null,
    accessoryRemarks: null,
    simRemarks: null,
    expectedHardwareDueDate: moment().add(1, 'weeks'),
    expectedSoftwareDueDate: moment().add(1, 'weeks'),
    expectedAccessoryDueDate: moment().add(1, 'weeks'),
    expectedSimsDueDate: moment().add(1, 'weeks'),
    approveOrReject: null,
    isCancelConfDialogOpen: false,
    isSaveConfDialogOpen: false,
    isDeleteConfDialogOpen: false
  }

  assignDevice = () => {
    this.props.history.push({
      pathname:
        '/home/subscriptions/assign/' +
        this.clientLoginId +
        '/' +
        this.subscriptionId
    })
  }

  handleAccountRemarksChange = e => {
    this.setState({ accountRemarks: e.target.value })

    // deassignDevice = () => {
    //   this.props.history.push({
    //     pathname:
    //       '/home/subscriptions/deassign/' +
    //       this.clientLoginId +
    //       '/' +
    //       this.subscriptionId
    //   })
    // }

    // deassignSim = () => {
    //   this.props.history.push({
    //     pathname:
    //       '/home/subscriptions/deassignSim/' +
    //       this.clientLoginId +
    //       '/' +
    //       this.subscriptionId
    //   })
    // }

    // handleAccountRemarksChange = e =>
    //   this.setState({ accountRemarks: e.target.value })
  }

  deassignDevice = () => {
    this.props.history.push({
      pathname:
        '/home/subscriptions/deassign/' +
        this.clientLoginId +
        '/' +
        this.subscriptionId
    })
  }

  deassignSim = () => {
    this.props.history.push({
      pathname:
        '/home/subscriptions/deassignSim/' +
        this.clientLoginId +
        '/' +
        this.subscriptionId
    })
  }

  getFormattedDate = date1 => {
    // const d1 = parseInt(date1, 10)
    // const unixEpochTimeMS = d1 * 1000
    // const d = new Date(unixEpochTimeMS)
    // // Careful, the string output here can vary by implementation...
    // const strDate = d.toLocaleDateString()
    // return strDate
    return moment(date1 * 1000).format('DD/MM/YYYY')
  }
  // getFormattedDate = timestamp => {
  //   moment.unix(parseInt(timestamp, 10)).format('DD/MM/YYYY')
  // }

  handleChangePaymentType = event => {
    this.setState({
      paymentMode: event.target.value,
      isValidReferenceNumber: true,
      referenceMessage: '',
      referenceNumber: null,
      bankName: null
    })
  }

  handleChangeReferenceNumber = event => {
    this.setState({ referenceNumber: event.target.value })
  }

  checkReferenceNumberValidity = () => {
    let regExValue = new RegExp(
      /(^[a-zA-Z0-9]{6,15})|(^[0-9]{6,15})|(^[a-zA-Z]{6,15})|(?!)$/
    )
    if (this.state.referenceNumber === null) {
      this.setState({
        isValidReferenceNumber: true,
        referenceMessage: 'Please enter Reference/DD/Check number'
      })
    } else if (
      regExValue.test(this.state.referenceNumber) &&
      this.state.referenceNumber !== ''
    ) {
      this.setState({
        isValidReferenceNumber: true,
        referenceMessage: ''
      })
    } else if (this.state.referenceNumber === '') {
      this.setState({
        isValidReferenceNumber: false,
        referenceMessage: 'Please enter Reference/DD/Check number'
      })
    } else {
      this.setState({
        isValidReferenceNumber: false,
        referenceMessage: 'Please enter a valid Reference/DD/Check number'
      })
    }
  }

  handleChangePaidMoney = event => {
    this.setState({ paidMoney: event.target.value })
  }

  handleChangeBankName = event => {
    this.setState({ bankName: event.target.value })
  }

  getPaymentId = () => {
    const {
      data: { subscription }
    } = this.props
    const { billingDetails } = subscription
    if (billingDetails !== null) {
      this.setState({ paymentId: billingDetails.paymentId })
    } else {
      this.setState({ paymentId: 0 })
    }
  }

  validateFields = () => {
    // console.log('this.state.paymentModeff', this.state.paymentMode)
    const {
      hardwarePaymentMade,
      softwarePaymentMade,
      simPaymentMade,
      accessoryPaymentMade
    } = this.state
    let regExValue = new RegExp(/^([a-zA-Z0-9_-]){5,25}$/)
    let regExValueBank = new RegExp(/^[A-Za-z\s]{3,30}$/)
    if (hardwarePaymentMade === '') {
      this.props.openSnackbar('Hardware payment made should not be blank!')
      return false
    } else if (this.state.accountRemarks.length > 100) {
      console.log(
        'this.state.accountRemarks.length',
        this.state.accountRemarks.length
      )
      this.props.openSnackbar('Remarks should be less than 100 Characters!')
      return false
    } else if (softwarePaymentMade === '') {
      this.props.openSnackbar('Software payment made should not be blank!')
      return false
    } else if (accessoryPaymentMade === '') {
      this.props.openSnackbar('Accessory payment made should not be blank!')
      return false
    } else if (simPaymentMade === '') {
      this.props.openSnackbar('Sim payment made should not be blank!')
      return false
    } else if (this.state.paymentMode === 'ONLINE') {
      if (
        this.state.referenceNumber === null ||
        !regExValue.test(this.state.referenceNumber)
      ) {
        this.props.openSnackbar(
          'Reference Number length Should between 5 to 25 and Alphanumeric'
        )
        this.setState({ validation: false })
        return false
      } else if (
        this.state.paidMoney < this.props.data.subscription.minimumAmountDue
      ) {
        this.props.openSnackbar(
          'Amount Should be greater than or equal to Min. due Amount!'
        )
        this.setState({ validation: false })
        return false
      } else {
        this.setState({ validation: true })
        return true
      }
    } else if (
      this.state.paymentMode === 'DD' ||
      this.state.paymentMode === 'CHEQUE'
    ) {
      if (!regExValue.test(this.state.referenceNumber)) {
        this.props.openSnackbar(
          'Reference Number length Should be between 5 to 25 and Alphanumeric'
        )
        this.setState({ validation: false })
        return false
      } else if (
        !regExValueBank.test(this.state.bankName) ||
        this.state.bankName === null
      ) {
        console.log('bank name', regExValueBank.test(this.state.bankName))
        this.props.openSnackbar(
          'Bank Name length Should be between 3 to 30 and only alphabets'
        )
        this.setState({ validation: false })
        return false
      } else if (
        this.state.paidMoney < this.props.data.subscription.minimumAmountDue
      ) {
        this.props.openSnackbar(
          'Amount Should be greater than or equal to Min. due Amount!'
        )
        this.setState({ validation: false })
        return false
      } else {
        console.log(
          'true validation amount',
          regExValueBank.test(this.state.bankName)
        )
        this.setState({ validation: true })
        return true
      }
    } else {
      console.log('true validation')
      this.setState({ validation: true })
      return true
    }
  }

  handleRejectMutation = async () => {
    const { data } = await this.props.client.mutate({
      mutation: APPROVE_REJECT_SUBSCRIPTION,
      variables: {
        clientLoginId: this.clientLoginId,
        paymentId: parseInt(this.props.paymentId, 10),
        subscriptionId: parseInt(this.subscriptionId, 10),
        approveOrReject: this.state.approveOrReject
      }
    })
    const { approveOrRejectSubscription } = data
    if (approveOrRejectSubscription) {
      this.props.openSnackbar('Subscription Rejected')
    }
    this.props.history.push({
      pathname: '/home/subscriptions/'
    })
  }

  handleCancelNegativeResponse = e => {
    this.setState({ isCancelConfDialogOpen: false })
  }

  handleSaveReject = () => {
    this.getPaymentId()
    this.setState({ approveOrReject: 'REJECTED' }, () => {
      // console.log('payment Id', this.state.paymentId)
      this.handleRejectMutation()
    })
    this.setState({ isCancelConfDialogOpen: false })
  }

  handleCancel = () => {
    this.setState({ isCancelConfDialogOpen: true })
  }

  handleApproveMutation = async () => {
    const { data, errors } = await this.props.client.mutate({
      mutation: APPROVE_REJECT_SUBSCRIPTION,
      variables: {
        clientLoginId: this.clientLoginId,
        subscriptionId: parseInt(this.subscriptionId, 10),
        paidDetails: {
          hardwareBill: {
            amountWithGST: parseInt(this.state.hardwarePaymentMade, 10),
            expectedDateTime: moment(this.state.expectedSoftwareDueDate)
              .unix()
              .toString(),
            accountsRemrks: this.state.hardwareRemarks
          },
          softwareBill: {
            amountWithGST: parseInt(this.state.softwarePaymentMade, 10),
            expectedDateTime: moment(this.state.expectedHardwareDueDate)
              .unix()
              .toString(),
            accountsRemrks: this.state.softwareRemarks
          },
          accessoryBill: {
            amountWithGST: parseInt(this.state.accessoryPaymentMade, 10),
            expectedDateTime: moment(this.state.expectedAccessoryDueDate)
              .unix()
              .toString(),
            accountsRemrks: this.state.accessoryRemarks
          },
          simBill: {
            amountWithGST: parseInt(this.state.simPaymentMade, 10),
            expectedDateTime: moment(this.state.expectedSimsDueDate)
              .unix()
              .toString(),
            accountsRemrks: this.state.simRemarks
          }
        },
        paymentMode: this.state.paymentMode,
        paymentId: parseInt(this.props.paymentId, 10),
        bankName: this.state.bankName,
        referenceNumber: this.state.referenceNumber,
        approveOrReject: this.state.approveOrReject,
        paymentRemarks: this.state.accountRemarks
      },
      errorPolicy: 'all'
    })

    // const { approveOrRejectSubscription } = data ? data : ''

    if (errors) {
      this.props.openSnackbar(errors[0].message, { type: 'error' })
    } else if (data.approveOrRejectSubscription) {
      this.props.openSnackbar(' Subscription Approved')
      this.props.history.goBack()
    }
  }

  handleSubmitApprove = () => {
    if (this.validateFields()) {
      this.setState({ isSaveConfDialogOpen: true })
    }
  }

  handleSaveNegativeResponse = e => {
    this.setState({ isSaveConfDialogOpen: false })
  }

  handleDeleteNegativeResponse = e => {
    this.setState({ isDeleteConfDialogOpen: false })
  }

  handleDeleteSubcription = e => {
    this.setState({ isDeleteConfDialogOpen: true })
  }

  handleSubmit = () => {
    this.setState({ isSaveConfDialogOpen: false })
    this.getPaymentId()
    if (this.validateFields()) {
      this.setState({ approveOrReject: 'APPROVED' }, () => {
        // console.log('payment Id', this.state.paymentId)
        this.handleApproveMutation()
      })
    }
  }

  deleteSubscription = async event => {
    // event.preventDefault()
    // console.log('hi')
    this.setState({ isDeleteConfDialogOpen: false })
    const { data, errors } = await this.props.client.mutate({
      mutation: DELETE_SUBSCRIPTION,
      variables: {
        clientLoginId: parseInt(this.clientLoginId),
        id: parseInt(this.subscriptionId, 10),
        partnerLoginId: getLoginId()
      }
    })
    if (data) {
      this.props.openSnackbar('Subscription Deleted Successfully')
      this.props.history.push({
        pathname: '/home/subscriptions'
      })
    } else {
      this.props.openSnackbar(errors[0].message)
    }
  }

  handleViewPIClick = event => {
    const PILink = this.props.data.subscription.invoiceDownloadLink
    if (PILink === null) alert('No PI uploaded.')
    else window.open(PILink, '_blank')
  }

  handlePaymentMade = name => event => {
    const { value } = event.target
    if (value >= 0) {
      this.setState({ [name]: value }, () => {
        this.calculateBalance(name)
      })
    }
  }

  calculateBalance = particularName => {
    const {
      hardwarePaymentMade,
      softwarePaymentMade,
      accessoryPaymentMade,
      simPaymentMade
    } = this.state
    const {
      data: { subscription }
    } = this.props
    const {
      billingDetails: { hardwareBill, softwareBill, accessoryBill, simBill }
    } = subscription
    // console.log('balance calculating:', particularName)
    let balanceAmount = 0
    if (particularName === 'hardwarePaymentMade') {
      balanceAmount = hardwareBill.amountWithGST - hardwarePaymentMade
      this.setState({ hardwareBalance: balanceAmount })
    }
    if (particularName === 'softwarePaymentMade') {
      balanceAmount = softwareBill.amountWithGST - softwarePaymentMade
      this.setState({ softwareBalance: balanceAmount })
    }
    if (particularName === 'accessoryPaymentMade') {
      balanceAmount = accessoryBill.amountWithGST - accessoryPaymentMade
      this.setState({ accessoryBalance: balanceAmount })
    }
    if (particularName === 'simPaymentMade') {
      balanceAmount = simBill.amountWithGST - simPaymentMade
      this.setState({ simBalance: balanceAmount })
    }
  }

  getGst = Gst => {
    return Gst * 100
  }

  handleRemarksChange = name => event => {
    const { value } = event.target
    this.setState({ [name]: value })
    // console.log('remarks', name, event)
  }

  handleExpectedDateChange = name => date => {
    this.setState({ [name]: date })
  }

  setInitialBalance = () => {
    const {
      subscription: { billingDetails }
    } = this.props.data
    if (billingDetails) {
      const {
        hardwareBill,
        softwareBill,
        accessoryBill,
        simBill
      } = billingDetails
      if (hardwareBill) {
        this.setState({ hardwareBalance: hardwareBill.amountWithGST })
      }
      if (softwareBill) {
        this.setState({ softwareBalance: softwareBill.amountWithGST })
      }
      if (accessoryBill) {
        this.setState({ accessoryBalance: accessoryBill.amountWithGST })
      }
      if (simBill) {
        this.setState({ simBalance: simBill.amountWithGST })
      }
    }
  }

  componentDidMount = () => {
    if (this.props.data.subscription) {
      this.setInitialBalance()
    }
  }

  getStatusType = status => {
    if (status === 1 || status === 4) {
      return 'Pending'
    } else if (status === 2 || status === 5) {
      return 'Approved'
    } else if (status === 3) {
      return 'Rejected'
    }
  }

  render() {
    const { classes, data } = this.props
    let assignDeviceButtonVisible = false

    if (
      (['INV'].includes(getAccountType()) &&
        data &&
        data.subscription &&
        data.subscription.unAssignedDeviceQuantity > 0) ||
      (data &&
        data.subscription &&
        data.subscription.unAssignedSimQuantity > 0) ||
      (data &&
        data.subscription &&
        data.subscription.unAssignedAccessoryQuantity > 0)
    ) {
      assignDeviceButtonVisible = true
    }
    // const { billingDetails } = data.subscription
    const { paymentMode } = this.state
    return (
      <Grid container>
        <Fragment>
          <ConfirmationalDialog
            isDialogOpen={this.state.isCancelConfDialogOpen}
            dialogMessage={'Are you sure you want to Reject?'}
            negativeResponseHandler={this.handleCancelNegativeResponse}
            positiveResponseHandler={this.handleSaveReject}
          />
          <ConfirmationalDialog
            isDialogOpen={this.state.isSaveConfDialogOpen}
            dialogMessage={'Are you sure you want to Approve?'}
            negativeResponseHandler={this.handleSaveNegativeResponse}
            positiveResponseHandler={this.handleSubmit}
          />
          <ConfirmationalDialog
            isDialogOpen={this.state.isDeleteConfDialogOpen}
            dialogMessage={'Are you sure you want to Delete Subscription?'}
            negativeResponseHandler={this.handleDeleteNegativeResponse}
            positiveResponseHandler={this.deleteSubscription}
          />
        </Fragment>
        <Grid item xs={12}>
          {data.subscription && (
            <Card
              className={classes.card}
              raised
              classes={{ action: classes.cardAction }}
              title={
                data.subscription
                  ? data.subscription.billingFrequency.frequency
                  : 'N/A'
              }
              subheader={
                data.subscription
                  ? this.getFormattedDate(data.subscription.createdAt)
                  : 'N/A'
              }
              action={
                <Fragment>
                  <Typography
                    variant="body1"
                    style={{ fontSize: '20px', paddingTop: '10%' }}
                  >
                    <span style={{ opacity: '.6' }}>Status:</span>
                    {data.subscription
                      ? this.getStatusType(data.subscription.status)
                      : 'N/A'}
                  </Typography>
                  {['PA'].includes(getAccountType()) && (
                    <Fragment>
                      <Hidden xsDown>
                        <Button
                          color="secondary"
                          variant="raised"
                          onClick={this.handleViewPIClick}
                        >
                          Download PI
                          <FileDownloadIcon
                            className={classes.fileDownloadIcon}
                          />
                        </Button>
                      </Hidden>
                      <Hidden smUp>
                        <div className={classes.centerAlign}>
                          <IconButton
                            color="secondary"
                            variant="raised"
                            onClick={this.handleViewPIClick}
                          >
                            Download PI
                            <FileDownloadIcon
                              className={classes.fileDownloadIcon}
                            />
                          </IconButton>
                        </div>
                      </Hidden>
                      <Hidden smUp>
                        <div className={classes.centerAlign}>
                          <IconButton
                            color="secondary"
                            onClick={this.handleViewPIClick}
                          >
                            <FileDownloadIcon />
                          </IconButton>
                        </div>
                        <Typography variant="body1">Download PI</Typography>
                        {/* <Typography variant="body1" align="center">
                          PI
                        </Typography> */}
                      </Hidden>
                    </Fragment>
                  )}
                </Fragment>
              }
            >
              <CardContent>
                <Grid container spacing={16}>
                  <Grid item xs={6} sm={4}>
                    <Typography variant="body2">Quantity:</Typography>
                    <Typography variant="body1">
                      {data.subscription
                        ? data.subscription.deviceQuantity
                        : 'N/A'}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} sm={4}>
                    <Typography variant="body2">MMTC:</Typography>
                    <Typography variant="body1">
                      &#8377;{' '}
                      {data.subscription
                        ? data.subscription.amount + ' /-'
                        : 'N/A'}
                    </Typography>
                  </Grid>

                  <Grid item xs={6} sm={4}>
                    <Typography variant="body2">
                      Un-assigned Quantity
                    </Typography>
                    <Typography variant="body1">
                      {data.subscription
                        ? data.subscription.unAssignedDeviceQuantity
                        : 'N/A'}
                    </Typography>
                  </Grid>

                  <Grid item xs={6} sm={4}>
                    <Typography variant="body2">Sales Remarks:</Typography>
                    <Typography variant="body1">
                      {data.subscription.salesRemarks
                        ? data.subscription.salesRemarks
                        : 'N/A'}
                    </Typography>
                  </Grid>

                  <Grid item xs={6} sm={4}>
                    <Typography variant="body2">Next Payment Date:</Typography>
                    <Typography variant="body1">
                      {data.subscription
                        ? this.getFormattedDate(
                            data.subscription.nextPaymentDate
                          )
                        : 'N/A'
                      // eslint-disable-next-line indent
                      }
                      {/* {data.subscription.nextPaymentDate} */}
                    </Typography>
                  </Grid>

                  <Grid item xs={6} sm={4}>
                    <Typography variant="body2">Bill Mode:</Typography>
                    <Typography variant="body1">
                      {data.subscription
                        ? data.subscription.billingMode.billingMode
                        : 'N/A'}
                    </Typography>
                  </Grid>

                  {!['SER', 'INV', 'SAL', 'ACC', 'PA'].includes(
                    getAccountType()
                  ) && (
                    <Grid item xs={6} sm={4}>
                      <Typography variant="body2">Min. Amount Due:</Typography>
                      <Typography variant="body1">
                        &#8377;{' '}
                        {data.subscription
                          ? data.subscription.minimumAmountDue
                          : 'N/A'}
                      </Typography>
                    </Grid>
                  )}

                  {/* <Grid item xs={6} sm={4}>
                    <Typography variant="body2">Sales Remarks:</Typography>
                    <Typography variant="body1">
                      {data.subscription
                        ? data.subscription.salesRemarks
                        : 'N/A'}
                    </Typography>
                  </Grid> */}
                </Grid>
              </CardContent>
              <CardActions>
                {this.viewVehicles && (
                  <Typography variant="body1">
                    <Button
                      color="secondary"
                      onClick={this.props.showSubscription(
                        this.props.subscriptionId
                      )}
                    >
                      View Vehicles
                    </Button>
                  </Typography>
                )}

                {/* eslint-disable indent */
                ['SAL', 'PA'].includes(getAccountType()) &&
                  (data.subscription.unAssignedDeviceQuantity ===
                    data.subscription.deviceQuantity &&
                    data.subscription.unAssignedSimQuantity ===
                      data.subscription.simQuantity &&
                    data.subscription.unAssignedAccessoryQuantity ===
                      data.subscription.accessoryQuantity) && (
                    <Typography variant="body1">
                      <Button
                        color="secondary"
                        onClick={this.deleteSubscription}
                      >
                        Delete Subscription
                      </Button>
                    </Typography>
                  )}

                {/* eslint-disable indent */
                ['INV', 'PA'].includes(getAccountType()) &&
                  (data.subscription.unAssignedDeviceQuantity > 0 ||
                    data.subscription.unAssignedSimQuantity > 0 ||
                    data.subscription.unAssignedAccessoryQuantity > 0) && (
                    <Typography variant="body1">
                      <Button
                        color="secondary"
                        onClick={() => this.assignDevice(this.backUrl)}
                      >
                        Assign Device
                      </Button>
                    </Typography>
                  )
                /* eslint-enable indent */
                }

                {/* eslint-disable indent */
                ['PA', 'INV'].includes(getAccountType()) &&
                  (data.subscription.unAssignedDeviceQuantity ===
                    data.subscription.deviceQuantity &&
                    data.subscription.unAssignedSimQuantity ===
                      data.subscription.simQuantity &&
                    data.subscription.unAssignedAccessoryQuantity ===
                      data.subscription.accessoryQuantity) &&
                  this.getStatusType(data.subscription.status) !==
                    'Approved' && (
                    <Typography variant="body1">
                      <Button
                        color="secondary"
                        onClick={this.handleDeleteSubcription}
                      >
                        Delete Subscription
                      </Button>
                    </Typography>
                  )
                /* eslint-enable indent */
                }
              </CardActions>
            </Card>
          )}
        </Grid>

        {/* Billing Details Module */}
        {!this.props.isFromCustomer && (
          <Grid item xs={12} className={classes.billingDetail}>
            <BillingDetails
              subcriptionData={data}
              hardwarePaymentMade={this.state.hardwarePaymentMade}
              softwarePaymentMade={this.state.softwarePaymentMade}
              accessoryPaymentMade={this.state.accessoryPaymentMade}
              simPaymentMade={this.state.simPaymentMade}
              hardwareBalance={this.state.hardwareBalance}
              softwareBalance={this.state.softwareBalance}
              accessoryBalance={this.state.accessoryBalance}
              simBalance={this.state.simBalance}
              hardwareRemarks={this.state.hardwareRemarks}
              softwareRemarks={this.state.softwareRemarks}
              accessoryRemarks={this.state.accessoryRemarks}
              simRemarks={this.state.simRemarks}
              expectedHardwareDueDate={this.state.expectedHardwareDueDate}
              expectedSoftwareDueDate={this.state.expectedSoftwareDueDate}
              expectedAccessoryDueDate={this.state.expectedAccessoryDueDate}
              expectedSimsDueDate={this.state.expectedSimsDueDate}
              handlePaymentMade={this.handlePaymentMade}
              handleRemarksChange={this.handleRemarksChange}
              handleExpectedDateChange={this.handleExpectedDateChange}
            />
          </Grid>
        )}

        {['ACC'].includes(getAccountType()) &&
          data.subscription.billingDetails && (
            <Grid
              item
              xs={
                12 // data.subscription.minimumAmountDue > 0 &&
              }
            >
              <Card className={classes.card} raised>
                <CardHeader title="Record Payment" />
                <CardContent>
                  <Grid container spacing={16}>
                    <Grid item xs={12}>
                      <FormControl className={classes.formControl}>
                        <InputLabel id="payment-helper">
                          Payment Type
                        </InputLabel>

                        <Select
                          labelId="payment-helper"
                          id="payment-helper-select"
                          value={this.state.paymentMode}
                          onChange={this.handleChangePaymentType}
                          className={classes.selectStyle}
                        >
                          {/* <MenuItem value="">
                            <em>None</em>
                          </MenuItem> */}
                          <MenuItem value={'NONE'}>None</MenuItem>
                          <MenuItem value={'CASH'}>Cash</MenuItem>
                          <MenuItem value={'ONLINE'}>Online</MenuItem>
                          <MenuItem value={'CHEQUE'}>Cheque</MenuItem>
                          <MenuItem value={'DD'}>DD</MenuItem>
                        </Select>
                        {/* <FormHelperText>Some important helper text</FormHelperText> */}
                      </FormControl>
                    </Grid>

                    {paymentOption.includes(this.state.paymentMode) && (
                      <Grid item xs={12}>
                        <PaymentMethod
                          paymentThrough={this.state.paymentMode}
                          handleChangereferenceNumber={
                            this.handleChangeReferenceNumber
                          }
                          checkReferenceNumberValidity={
                            this.checkReferenceNumberValidity
                          }
                          isValidReferenceNumber={
                            this.state.isValidReferenceNumber
                          }
                          referenceMessage={this.state.referenceMessage}
                          handleChangeBankName={this.handleChangeBankName}
                          handleChangePaidMoney={this.handleChangePaidMoney}
                          referenceNumber={
                            this.state.referenceNumber // paidMoney={this.state.paidMoney}
                          }
                          bankName={this.state.bankName}
                        />
                      </Grid>
                    )}

                    <Grid item xs={12}>
                      <TextField
                        multiline
                        rows={4}
                        label="Remarks"
                        variant="contained"
                        onChange={this.handleAccountRemarksChange}
                        value={this.state.accountRemarks}
                        className={classes.selectStyle}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
                <CardActions>
                  <Button
                    variant="contained"
                    color="secondary"
                    classes={{ root: classes.redButton }}
                    onClick={this.handleCancel}
                  >
                    Reject
                  </Button>
                  <Button
                    disabled={paymentMode === ''}
                    variant="contained"
                    color="secondary"
                    type="submit"
                    onClick={this.handleSubmitApprove}
                  >
                    Approve
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          )}
      </Grid>
    )
  }
}

SubscriptionDetails.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withApollo(
  withRouter(
    withSharedSnackbar(
      withStyles(styles)(props => {
        // console.log('props data', props)
        return (
          <Query
            query={GET_SUBSCRIPTION} // TODO: Change Query
            variables={{
              subscriptionId: parseInt(props.subscriptionId, 10)
            }}
            // fetchPolicy="network-only"
          >
            {({ loading, error, data }) => {
              // console.log('get subscription data', data)

              if (loading) return props.disableLoader ? null : <Loader />
              if (error) return `Error!: ${error}`

              return <SubscriptionDetails {...props} data={data} />
            }}
          </Query>
        )
      })
    )
  )
)



// WEBPACK FOOTER //
// ./src/components/Pages/ViewSubscription/subscriptionDetails.jsx